/*
 * @Author: ct
 * @Date: 2022-06-14 13:53:01
 * @LastEditors: ct
 * @LastEditTime: 2022-06-14 18:46:16
 * @FilePath: /com_light2_web/src/store/modules/monitor.js
 */

export default {
  state: {
    flooterList: "",
    areaHistoryEnergyParas: null
  },
  mutations: {
    setFlooterList(state, data) {
      state.flooterList = data
    },
    setAreaHistoryEnergyParas(state, data) {
      state.areaHistoryEnergyParas = data
    }
  },
  actions: {
    chaneAreaHistoryEnergyParas(store, {
      name,
      data
    }) {
      store.commit('setAreaHistoryEnergyParas', data);

      setLocalStoragItem(name, JSON.stringify(data));
    },
  },

}
